import React from 'react';
import classNames from 'classnames';
import Tooltip from '../Tooltip';
import defaultAvatarContent from './assets/default-avatar-svg';
var defaultAvatarUrl = "data:image/svg+xml;base64,".concat(btoa(defaultAvatarContent));
var STYLE_NAMESPACE = 'vcp-user-avatars';
var UserAvatar = function (_a) {
    var item = _a.item, size = _a.size, onClick = _a.onClick, getOverlay = _a.getOverlay, className = _a.className, disableTooltip = _a.disableTooltip;
    var _b = React.useMemo(function () {
        var getTooltipOverlay = function (item) {
            if (getOverlay) {
                return Array.isArray(item) ? item.map(getOverlay) : getOverlay(item);
            }
            else {
                return Array.isArray(item)
                    ? item.map(function (_a) {
                        var name = _a.name;
                        return name;
                    }).join(', ')
                    : item.name;
            }
        };
        if (Array.isArray(item)) {
            return {
                onClickHandler: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); },
                tooltipOverlay: getTooltipOverlay(item),
                isActive: item.some(function (_a) {
                    var isActive = _a.isActive;
                    return isActive;
                }),
                isDisable: false,
                render: (React.createElement(React.Fragment, null,
                    "+",
                    React.createElement("span", null, item.length))),
            };
        }
        else {
            var id_1 = item.id, name_1 = item.name, isActive_1 = item.isActive, isDisable_1 = item.isDisable, image = item.image;
            return {
                onClickHandler: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(id_1); },
                tooltipOverlay: getTooltipOverlay(item),
                isActive: isActive_1,
                isDisable: isDisable_1,
                render: React.createElement(AvatarImage, { src: image, alt: name_1 }),
            };
        }
    }, [onClick, item]), render = _b.render, tooltipOverlay = _b.tooltipOverlay, isActive = _b.isActive, isDisable = _b.isDisable, onClickHandler = _b.onClickHandler;
    return (React.createElement(Tooltip, { overlay: tooltipOverlay, trigger: disableTooltip ? 'none' : 'hover' },
        React.createElement("div", { onClick: onClick ? onClickHandler : undefined, className: classNames([
                "".concat(STYLE_NAMESPACE, "-item"),
                "".concat(STYLE_NAMESPACE, "-size-").concat(size),
                isActive && "".concat(STYLE_NAMESPACE, "-is-active"),
                isDisable && "".concat(STYLE_NAMESPACE, "-is-disable"),
                onClick && "".concat(STYLE_NAMESPACE, "-is-interactive"),
                Array.isArray(item) && "".concat(STYLE_NAMESPACE, "-additional-label"),
                className,
            ]) }, render)));
};
var AvatarImage = function (_a) {
    var src = _a.src, alt = _a.alt;
    var _b = React.useState(src), imageUrl = _b[0], setImageUrl = _b[1];
    React.useEffect(function () { return setImageUrl(src); }, [src]);
    var onLoadImageError = React.useCallback(function () {
        setImageUrl(defaultAvatarUrl);
    }, []);
    return (React.createElement("img", { src: imageUrl || defaultAvatarUrl, className: "".concat(STYLE_NAMESPACE, "-img"), alt: alt, onError: onLoadImageError }));
};
export default React.memo(UserAvatar);
